var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgApproved = function SvgApproved(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.807 7.92398C21.677 6.69698 20.772 5.09698 19.795 4.36898C19.795 4.36898 18.335 3.28098 16.501 2.19898C14.667 1.12298 13.014 0.375977 13.014 0.375977C11.907 -0.124023 10.096 -0.124023 8.99 0.375977C8.99 0.375977 7.334 1.12298 5.5 2.20198C3.667 3.28398 2.206 4.37198 2.206 4.37198C1.23 5.09598 0.323 6.69598 0.194 7.92298C0.194 7.92298 0 9.75698 0 11.917C0 14.077 0.194 15.912 0.194 15.912C0.324 17.14 1.229 18.739 2.204 19.466C2.206 19.466 3.667 20.556 5.5 21.636C7.334 22.716 8.99 23.462 8.99 23.462C10.095 23.96 11.906 23.96 13.013 23.462C13.013 23.462 14.666 22.716 16.5 21.635C18.334 20.555 19.795 19.465 19.795 19.465C20.772 18.739 21.677 17.14 21.807 15.912C21.807 15.912 22 14.078 22 11.917C22 9.75698 21.807 7.92298 21.807 7.92298V7.92398ZM9.3 17.18L4.3 12.18L5.713 10.767L9.3 14.353L16.288 7.36498L17.702 8.77898L9.299 17.179L9.3 17.18Z",
    fill: "#84BF41"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApproved, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/approved.c4337127.svg";
export { ForwardRef as ReactComponent };